import React from 'react';

import {ActionsButton} from 'app/general/widgets/ActionsButton';
import {useRemoveTeamItem, useUpdateMemberAccess} from 'app/teams/api';
import {getMembership} from 'app/teams/utils';
import {gt} from 'app/utils/i18n';

import {FullHTMLLink} from '../FullHTMLLink';

import type {GenericAttachedItemProps} from './AddToTeamPopover';
import type {UserSerializedType} from 'sweet-types';

interface UserAttachedItemProps extends GenericAttachedItemProps {
  user: UserSerializedType;
}

export function UserAttachedItem({user, item}: UserAttachedItemProps) {
  const [removeTeamitem] = useRemoveTeamItem();
  const [updateMemberAccess] = useUpdateMemberAccess();
  const membership = getMembership(user, item);

  const availableActions = [
    {
      text: gt('Team Manager'),
      icon: `far fa-${membership?.access == 'manager' ? 'check-' : ''}square`,
      key: 'manager',
      disabled: membership?.access == 'manager',
      condition: () => item.can_edit,
      callback: () =>
        updateMemberAccess({
          url: membership!.url,
          access: 'manager',
          userUrl: user.url,
        }),
    },
    {
      text: gt('Team Member'),
      key: 'teammember',
      icon: `far fa-${membership?.access == 'teammate' ? 'check-' : ''}square`,
      disabled: membership?.access == 'teammate',
      condition: () => item.can_edit,
      callback: () =>
        updateMemberAccess({
          url: membership!.url,
          access: 'teammate',
          userUrl: user.url,
        }),
    },
    {
      text: gt('Read Only Member'),
      key: 'reader',
      icon: `far fa-${membership?.access == 'reader' ? 'check-' : ''}square`,
      disabled: membership?.access == 'reader',
      condition: () => item.can_edit,
      callback: () =>
        updateMemberAccess({
          url: membership!.url,
          access: 'reader',
          userUrl: user.url,
        }),
    },
    {
      text: gt('Remove from Team'),
      key: 'remove',
      icon: 'fa fa-times',
      condition: () => item.can_edit,
      callback: () => removeTeamitem({teamURL: item.url, item: user}),
    },
  ];

  return (
    <>
      <FullHTMLLink
        html_url={item.html_url}
        className="text-white text-truncate py-2"
      >
        {item.name}
      </FullHTMLLink>
      <ActionsButton actions={availableActions} fixedDropdown={true}>
        {(buttonProps) => (
          <button
            {...buttonProps}
            className="btn btn-sm btn-link text-white mr-1"
          />
        )}
      </ActionsButton>
    </>
  );
}
